<template>
  <v-container fluid fill-height align-start ma-0 pa-2>
    <v-row no-gutters align-content="start" justify="center">
      <v-card :width="mobileTrigger ? '100%' : '1280'" class="pa-0">
        <v-col cols="12" sm="12" lg="12" class="pa-2 pb-0">
          <i-card-top
            class="d-md-flex"
            headerTitle
            :useBtnList="buttonUseList"
            @btnSave="btnSave(false)"
            @btnSearch="btnSearch(true)"
          >
            <template v-slot:body>
              <v-layout>
                <v-row no-gutters class="pa-0">
                  <v-col cols="12" class="pa-2 pb-0">
                    <v-row no-gutters>
                      <v-spacer />
                      <v-btn
                        color="primary"
                        small
                        elevation="0"
                        class="rounded"
                        @click="constructApproval()"
                      >승인요청</v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-layout>
            </template>
          </i-card-top>
        </v-col>
        <v-col cols="12" sm="12" lg="12" class="pa-2 px-4 pb-0">
          <v-row no-gutters>
            <v-col cols="12">
              <i-card-vertical headerTitle="공사관리" :IsUseInnerAddition="true" device="web">
                <template v-slot:innerAddition>
                  <v-btn
                    color="primary"
                    small
                    elevation="0"
                    outlined
                    class="rounded"
                    @click="btnCancel()"
                  >
                    <v-icon left>mdi-exit-to-app</v-icon>목록으로
                  </v-btn>
                </template>
                <template v-slot:body>
                  <!-- 계약 승인 텍스트 -->
                  <v-row v-if="constructData.approvalStatus === 'A'" no-gutters>
                    <v-col cols="12" class="text-right pt-5">
                      <div
                        class="construct-approval-text"
                        style="color: #1E96FF;"
                      >계약 승인된 공사입니다. {{ constructData.contractDt }}</div>
                    </v-col>
                  </v-row>
                  <!-- v-form 시작 -->
                  <v-form ref="form">
                    <v-row no-gutters class="pt-5">
                      <v-col cols="12" class>
                        <v-row no-gutters>
                          <v-col cols="6" class="pr-4">
                            <div class="form-label">공사명*</div>
                            <v-text-field
                              dense
                              v-model="constructData.constructNm"
                              outlined
                              maxlength="300"
                              :rules="[rules.required]"
                              clearable
                            />
                          </v-col>
                          <v-col cols="3" class="pl-4 pr-4">
                            <div class="form-label">사용 시작일*</div>
                            <v-menu
                              v-model="constDtS"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="startDate"
                                  class
                                  hint="YYYY-MM-DD"
                                  prepend-icon="mdi-calendar"
                                  v-bind="attrs"
                                  v-on="on"
                                  outlined
                                  dense
                                  readonly
                                  :rules="[rules.required, rules.constructDateMatch]"
                                  clearable
                                />
                              </template>
                              <v-date-picker
                                v-model="startDate"
                                no-title
                                scrollable
                                @input="constDtS = false"
                              />
                            </v-menu>
                          </v-col>

                          <v-col cols="3" class="pl-4">
                            <div class="form-label">사용 종료일*</div>
                            <v-menu
                              v-model="constDtE"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="endDate"
                                  class
                                  hint="YYYY-MM-DD"
                                  prepend-icon="mdi-calendar"
                                  v-bind="attrs"
                                  v-on="on"
                                  outlined
                                  dense
                                  readonly
                                  :rules="[rules.required, rules.constructDateMatch]"
                                  clearable
                                />
                              </template>
                              <v-date-picker
                                v-model="endDate"
                                no-title
                                scrollable
                                @input="constDtE = false"
                              />
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="7" class>
                        <v-row no-gutters>
                          <v-col cols="6" class="pr-4">
                            <div class="form-label">공사진행상태*</div>
                            <DxDropDownBox
                              class="hidden-sm-and-down"
                              ref="dropDownBoxRefDataset"
                              :value="constructData.constructStatus"
                              placeholder="공사진행상태"
                              :drop-down-options="{ width: '100%' }"
                              :defer-rendering="false"
                              :data-source="constructStatusList"
                              :display-expr="`minorNm`"
                              value-expr="minorCd"
                            >
                              <div style="margin: 10px !important;">
                                <DxDataGrid
                                  :data-source="constructStatusList"
                                  :hover-state-enabled="true"
                                  :focused-row-enabled="true"
                                  width="100%"
                                  height="500px"
                                  :word-wrap-enabled="true"
                                  :show-row-lines="true"
                                  :editing="{ allowUpdating: false }"
                                  :selection="{ mode: 'single', deferred: false }"
                                  :filter-row="{ visible: true }"
                                  :on-content-ready="() => {}"
                                  key-expr="minorCd"
                                  @selection-changed="e => onConstructSelectionChanged(e)"
                                  :on-initialized="() => null"
                                >
                                  <DxPaging :enabled="true" :page-size="5" />
                                  <DxColumn data-field="minorNm" caption="공사명" width="100%" />
                                </DxDataGrid>
                              </div>
                            </DxDropDownBox>
                            <div
                              v-if="constructStatusFlag"
                              class="pl-4"
                              style="font-size: 12px; color: #F44336; font-weight: 600;"
                            >필수 입력 사항입니다.</div>
                          </v-col>
                          <v-col cols="6" class="pl-4">
                            <div class="form-label">사업장선택*</div>
                            <DxDropDownBox
                              class="hidden-sm-and-down"
                              ref="dropDownBoxRefComp"
                              :value="constructData.compId"
                              placeholder="사업장선택"
                              :drop-down-options="{ width: '100%' }"
                              :defer-rendering="false"
                              :data-source="companyInfoList"
                              :display-expr="`compNm`"
                              value-expr="compId"
                            >
                              <div style="margin: 10px !important;">
                                <DxDataGrid
                                  :data-source="companyInfoList"
                                  ref="dataGridRef"
                                  :hover-state-enabled="true"
                                  :focused-row-enabled="true"
                                  width="100%"
                                  height="500px"
                                  :word-wrap-enabled="true"
                                  :show-row-lines="true"
                                  :editing="{ allowUpdating: false }"
                                  :selection="{ mode: 'single', deferred: false }"
                                  :filter-row="{ visible: true }"
                                  :on-content-ready="() => {}"
                                  key-expr="uniqueKey"
                                  @selection-changed="e => onCompanySelectionChanged(e)"
                                  :on-initialized="() => null"
                                  :on-row-prepared="onRowPrepared"
                                >
                                  <DxPaging :enabled="true" :page-size="5" />
                                  <DxColumn data-field="compNm" caption="사업장명" width="80%" />
                                  <DxColumn
                                    data-field="completeCnt"
                                    alignment="center"
                                    caption="승인"
                                    width="20%"
                                  />
                                </DxDataGrid>
                              </div>
                            </DxDropDownBox>
                            <div
                              v-if="companyIdFlag"
                              class="pl-4"
                              style="font-size: 12px; color: #F44336; font-weight: 600;"
                            >필수 입력 사항입니다.</div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="5" class="pl-4">
                        <v-row no-gutters>
                          <v-col cols="12" class="pl-4">
                            <div class="form-label">공사비용*</div>
                            <v-text-field
                              class="right-input"
                              dense
                              v-model="formattedConstructAmount"
                              @input="handleInput"
                              prefix="￦"
                              outlined
                              maxlength="20"
                              :rules="[rules.required, rules.constructAmountMatch]"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <div class="form-label">공사개요</div>
                        <v-textarea
                          v-model="constructData.constructOverview"
                          no-resize
                          rows="10"
                          outlined
                          class
                        />
                      </v-col>
                      <v-col cols="12">
                        <div class="form-label">소재지</div>
                        <v-text-field
                          dense
                          v-model="constructData.constructLocation"
                          outlined
                          maxlength="150"
                          clearable
                        />
                      </v-col>
                      <v-col cols="12">
                        <div class="form-label">관리자 코멘트</div>
                        <v-textarea
                          readonly
                          v-model="constructData.adminComment"
                          no-resize
                          rows="5"
                          outlined
                          class
                        />
                      </v-col>
                      <!-- 파일 업로드 -->
                      <v-col cols="12" class="pb-4 pt-4">
                        <iFileManage
                          ref="detailFileUpload"
                          :readOnly="fileReadOnly"
                          :targetId="targetId"
                          targetType="00014"
                          @onFileChanged="onFileChanged"
                        />
                      </v-col>
                    </v-row>
                  </v-form>
                </template>
              </i-card-vertical>
            </v-col>
          </v-row>
        </v-col>
      </v-card>
    </v-row>
  </v-container>
</template>
<script>
import {
  approveConstructManageDetail,
  getConstructManageDetail,
  getConstructManageDetailCommonCode,
  reApproveConstructManageDetail,
  saveConstructManageDetail
} from '@/api/sojunganManagement/constructManage'
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import iFileManage from '@/components/esgCommon/iFileManage.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import baseview from '@/views/base/baseview.vue'
import DxDropDownBox from 'devextreme-vue/drop-down-box'
import notify from 'devextreme/ui/notify'
import Vue from 'vue'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    'i-card-top': iCardTop,
    'i-card-vertical': iCardVertical,
    DxDropDownBox,
    iFileManage
  },
  data() {
    return {
      constDtS: false,
      constDtE: false,
      buttonUseList: [
        'btnSearch', //조회
        'btnSave' //저장
      ],
      startDate: null,
      endDate: null,
      constructStatusList: [], // 공사진행상태 리스트(공통)
      companyInfoList: [], // 사업장선택 리스트(공통)
      constructStatusFlag: false,
      companyIdFlag: false,
      constructData: {
        clntId: null,
        writeDt: null,
        docNo: null,
        constructNm: null, // 공사명
        constructDtS: null, // 사용 시작일
        constructDtE: null, // 사용 종료일
        constructStatus: null, // 공사진행상태
        compId: null, // 사업장코드(사업장번호)
        compNm: null, // 사업장명
        constructAmount: null, // 공사비용
        constructOverview: null, // 공사 개요
        constructLocation: null, // 소재지
        adminComment: null, // 관리자 코멘트
        __created__: false
      },
      mainData: {},
      fileList: [],
      targetId: null,
      formData: new FormData(),
      fileReadOnly: true,
      applyValidation: false,
      rgstNoPattern: /^[0-9]{3}-[0-9]{2}-[0-9]{5}$/,
      constructAmountPattern: /^[0-9]*$/,
      rules: {
        required: value => (this.applyValidation && !value ? '필수 입력 사항입니다.' : true),
        constructAmountMatch: value => {
          const numericValue = value.replace(/,/g, '')
          return !numericValue || /^[0-9]+(\.[0-9]{1,2})?$/.test(numericValue) || '숫자만 입력가능합니다.'
        },
        constructDateMatch: () =>
          !(this.startDate != null && this.endDate != null && this.startDate.replace(/-/g, '') > this.endDate.replace(/-/g, '')) ||
          '날짜가 허용된 범위를 넘었습니다.'
      }
    }
  },
  created() {},
  beforeMount() {},
  mounted() {
    if (!this.$route.params.data) {
      this.$router.go(-1)
      return
    }
  },
  async activated() {
    if (this.$route.params.data) {
      this.mainData = this.$route.params.data
      this.constructData.__created__ = this.$route.params.data.__created__
      this.constructData.clntId = this.$route.params.data.clntId
      if (this.$route.params.data.compId != undefined && this.$route.params.data.writeDt != undefined && this.$route.params.data.docNo != undefined) {
        this.constructData.compId = this.$route.params.data.compId
        this.constructData.writeDt = this.$route.params.data.writeDt
        this.constructData.docNo = this.$route.params.data.docNo
      }

      if (this.mainData.__created__) {
        this.getConstructManageDetailCommonCode()
        this.initializeData()
      } else {
        this.btnSearch(true)
      }
    }
  },
  watch: {
    startDate(newVal, oldVal) {
      if (newVal !== oldVal && newVal != null) {
        this.constructData.constructDtS = newVal.replace(/[^0-9]/g, '')
      }
    },
    endDate(newVal, oldVal) {
      if (newVal !== oldVal && newVal != null) {
        this.constructData.constructDtE = newVal.replace(/[^0-9]/g, '')
      }
    }
  },
  computed: {
    mobileTrigger: function() {
      return this.width < 800
    },
    formattedConstructAmount: {
      get() {
        if (!this.constructData.constructAmount) return ''
        return this.constructData.constructAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      set(value) {
        value = value.replace(/,/g, '')
        this.constructData.constructAmount = parseFloat(value.replace(/,/g, '')) || ''
      }
    }
  },
  methods: {
    async initializeData() {
      this.applyValidation = false
      this.fileReadOnly = true
      this.startDate = null
      this.endDate = null
      ;(this.constructData = {
        clntId: null,
        writeDt: null,
        docNo: null,
        constructNm: null, // 공사명
        constructDtS: null, // 사용 시작일
        constructDtE: null, // 사용 종료일
        constructStatus: null, // 공사진행상태
        compId: null, // 사업장코드(사업장번호)
        compNm: null, // 사업장명
        constructAmount: null, // 공사비용
        constructOverview: null, // 공사 개요
        constructLocation: null, // 소재지
        adminComment: null, // 관리자 코멘트
        __created__: true
      }),
        (this.constructStatusList = [])
      this.companyInfoList = []
      this.targetId = null
      Vue.nextTick(() => {
        this.$refs.detailFileUpload.btnSearch(false)
      })
    },
    //------------------------------------------
    //  공통코드 조회
    //------------------------------------------
    async getConstructManageDetailCommonCode() {
      try {
        let params = {
          clntId: this.getClntId()
        }
        const response = await getConstructManageDetailCommonCode(params, false)
        this.constructStatusList = response.constructStatusList
        this.companyInfoList = response.companyInfoList
        this.companyInfoList = response.companyInfoList.map(item => {
          item.uniqueKey = `${item.compId}${item.compNm}`
          item.completeCnt = item.completeCnt == 1 ? '승인' : ''
          return item
        })
      } catch (error) {
        console.error('getCommonCode error catch >> ', error)
      }
    },
    //------------------------------------------
    //  공사 조회
    //------------------------------------------
    async btnSearch(flag) {
      this.getConstructManageDetailCommonCode()
      this.constructStatusFlag = false
      this.companyIdFlag = false

      if (this.mainData.__created__) {
        await this.initializeData()
        return
      }

      this.openLoading()
      ;(this.applyValidation = false), (this.formData = new FormData())
      this.fileReadOnly = false
      this.startDate = null
      this.endDate = null
      ;(this.constructData = {
        clntId: null,
        writeDt: null,
        docNo: null,
        constructNm: null, // 공사명
        constructDtS: null, // 사용 시작일
        constructDtE: null, // 사용 종료일
        constructStatus: null, // 공사진행상태
        compId: null, // 사업장코드(사업장번호)
        compNm: null, // 사업장명
        constructAmount: null, // 공사비용
        constructOverview: null, // 공사 개요
        constructLocation: null, // 소재지
        adminComment: null, // 관리자 코멘트
        __created__: false
      }),
        (this.constructStatusList = [])
      this.companyInfoList = []

      let params = {
        clntId: this.mainData.clntId,
        compId: this.mainData.compId,
        writeDt: this.mainData.writeDt,
        docNo: this.mainData.docNo
      }

      try {
        const response = await getConstructManageDetail(params, flag)
        this.constructData = response
        this.constructData.constructAmount = response.constructAmount.toString()
        if (response.contractDt !== null) {
          this.constructData.contractDt = `(${response.contractDt.slice(0, 4)}-${response.contractDt.slice(4, 6)}-${response.contractDt.slice(6, 8)})`
        }
        this.startDate = this.formatDate(response.constructDtS)
        this.endDate = this.formatDate(response.constructDtE)
        this.targetId = response.clntId + '_' + response.compId + '_' + response.writeDt + '_' + response.docNo
        Vue.nextTick(() => {
          this.$refs.detailFileUpload.btnSearch(false)
        })
      } catch (error) {
        console.error('getConstructManageDetail error catch >> ', error)
      } finally {
        this.endLoading()
      }
    },
    //------------------------------------------
    //  공사 저장
    //------------------------------------------
    async btnSave(flag) {
      this.applyValidation = true
      const validate = this.$refs.form.validate()

      if (this.constructData.constructStatus == null) {
        this.constructStatusFlag = true
      }
      if (this.constructData.compId == null) {
        this.companyIdFlag = true
      }
      if (!validate || this.constructStatusFlag || this.companyIdFlag) {
        this.vToastify(this.$t('저장 입력 항목을 확인해주세요.'), 'info')
        return
      }

      Object.keys(this.constructData).forEach(key => {
        if (this.constructData[key] != null) {
          this.formData.append(`constructManageDetailData.${key}`, this.constructData[key])
        }
      })

      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        async () => {
          this.openLoading()
          try {
            const response = await saveConstructManageDetail(this.formData)
            console.log('[response] saveCompany()', response)
            if (response.msg) {
              this.vToastify(this.$t(response.msg), 'info')
              return
            } else {
              if (!this.constructData.__created__) {
                if (this.fileList.insert || this.fileList.delete) {
                  this.$refs.detailFileUpload.btnSave(this.fileList)
                  this.fileList = {
                    insert: [],
                    delete: []
                  }
                }
              }
              let data = {}
              Object.defineProperty(data, 'clntId', { value: response.clntId })
              Object.defineProperty(data, 'compId', { value: response.compId })
              Object.defineProperty(data, 'writeDt', { value: response.writeDt })
              Object.defineProperty(data, 'docNo', { value: response.docNo })
              Object.defineProperty(data, '__created__', { value: false })
              this.mainData = data
            }
            notify(this.$t('저장되었습니다.'), 'success', 1000)

            await this.btnSearch(false)
            if (flag) {
              this.constructApproval()
            }
          } catch (error) {
            console.error('saveConstructManageDetail error catch >> ', error)
          } finally {
            this.formData = new FormData()

            this.endLoading()
          }
        },
        null,
        true
      )
    },
    //------------------------------------------
    //  공사 목록 이동
    //------------------------------------------
    btnCancel() {
      this.vToastifyPrompt(this.$t('작성을 중지하고 이전 페이지로 이동하시겠습니까?'), 'info', async current => {
        const toRouter = {
          name: 'ConstructManage',
          params: {
            data: { flag: true }
          }
        }
        this.$router.push(toRouter)
      })
    },
    //------------------------------------------
    //  공사 승인
    //------------------------------------------
    async constructApproval() {
      if (this.constructData.__created__) {
        await this.btnSave(true)
        return
      } else {
        const statusMessages = {
          R: '승인거절된 공사입니다. 재요청 하시겠습니까?',
          A: '이미 승인된 공사입니다.',
          N: '이미 승인요청한 공사입니다',
          null: '승인요청 하시겠습니까?'
        }
        const message = statusMessages[this.constructData.approvalStatus]

        let params = {
          clntId: this.mainData.clntId,
          compId: this.mainData.compId,
          writeDt: this.mainData.writeDt,
          docNo: this.mainData.docNo
        }

        if (this.constructData.approvalStatus === null) {
          this.vToastifyPrompt(
            this.$t(message),
            'info',
            async () => {
              try {
                const response = await approveConstructManageDetail(params)
                if (response.msg) {
                  if (response.code) {
                    this.vToastifyPrompt(
                      this.$t(response.msg),
                      'info',
                      async () => {
                        await reApproveConstructManageDetail(params)
                        this.vToastify(this.$t('재승인요청 하였습니다.'), 'info')
                      },
                      null,
                      true
                    )
                    return
                  }
                  this.vToastify(this.$t(response.msg), 'info')
                  return
                } else {
                  this.vToastify(this.$t('승인요청 하였습니다.'), 'info')
                }
              } catch (error) {
                console.error('approveConstructManageDetail error catch >> ', error)
              } finally {
                this.btnSearch(false)
              }
            },
            null,
            true
          )
          return
        } else if (this.constructData.approvalStatus === 'R') {
          this.vToastifyPrompt(
            this.$t(message),
            'info',
            async () => {
              try {
                const response = await reApproveConstructManageDetail(params)
                if (response.msg) {
                  this.vToastify(this.$t(response.msg), 'info')
                }
              } catch (error) {
                console.error('reApproveConstructManageDetail error catch >> ', error)
              } finally {
                this.btnSearch(false)
              }
            },
            null,
            true
          )
          return
        } else if (this.constructData.approvalStatus === 'A') {
          this.vToastify(this.$t(message), 'info')
          return
        } else if (this.constructData.approvalStatus === 'N') {
          this.vToastify(this.$t(message), 'info')
          return
        }
      }
    },
    //------------------------------------------
    //  파일 저장
    //------------------------------------------
    onFileChanged(fileList) {
      this.fileList = fileList
      this.formData = new FormData()
      let i = 0
      this.fileList.insert.forEach(element => {
        this.formData.append('fileList[' + i + '].fileData', element.file ? element.file : new Blob([], { type: 'application/octet-stream' }))
        this.formData.append('fileList[' + i + '].fileVO.targetId', element.targetId)
        this.formData.append('fileList[' + i + '].fileVO.targetType', element.targetType)
        this.formData.append('fileList[' + i + '].fileVO.useYn', element.useYn)
        this.formData.append('fileList[' + i + '].fileVO.clntId', element.clntId)
        i++
      })
    },
    //------------------------------------------
    //  날짜 포맷
    //------------------------------------------
    formatDate(date) {
      const year = date.substring(0, 4)
      const month = date.substring(4, 6)
      const day = date.substring(6, 8)
      return `${year}-${month}-${day}`
    },
    handleInput(event) {
      let value
      if (event && event.target && typeof event.target.value === 'string') {
        value = event.target.value
      } else if (typeof event === 'string') {
        value = event
      }

      const regex = /[^\d.]/g
      if (value && regex.test(value)) {
        value = value.replace(regex, '')
        this.formattedConstructAmount = value
      }
    },
    //------------------------------------------
    //  DxGrid Event
    //------------------------------------------
    onConstructSelectionChanged(e) {
      if (e.selectedRowsData.length > 0) {
        console.log(e.selectedRowsData[0])
        const selectedData = e.selectedRowsData[0]
        console.log(selectedData)
        this.constructData.constructStatus = selectedData.minorCd
        this.constructStatusFlag = false

        this.$refs.dropDownBoxRefDataset.instance.close()
      } else {
        this.constructData.constructStatus = null
        this.$refs.dropDownBoxRefDataset.instance.close()
      }
    },
    onCompanySelectionChanged(e) {
      if (e.selectedRowsData.length > 0) {
        if (e.selectedRowsData[0].useYn === 'N') {
          return
        }
        const selectedData = e.selectedRowsData[0]
        this.constructData.compId = selectedData.compId
        if (selectedData.addrs != null) {
          this.constructData.constructLocation = selectedData.addrs
        }
        this.fileReadOnly = false
        this.companyIdFlag = false
        this.$refs.dropDownBoxRefComp.instance.close()
      } else {
        this.constructData.compId = null
        this.$refs.dropDownBoxRefComp.instance.close()
      }
    },
    onRowPrepared(e) {
      if (e.rowType == 'data' && e.data.useYn == 'N') {
        e.rowElement.style.backgroundColor = '#e9e9e9' // Light red background
      }
    }
  }
}
</script>
  
<style scoped>
.construct-approval-text {
  font-size: 16px;
  font-weight: 600;
}
.right-input >>> input {
  text-align: right;
}
</style>

  